import { OcpsPolicy } from '@ms/yammer-data/dist/state/ocps/types';
import { useIsFeedbackEnabled } from '@ms/yammer-hooks/dist/ocps';

import { UseUIFeatureCheck } from '../types';

export const useIsUserFeedbackEnabled: UseUIFeatureCheck = () =>
  useIsFeedbackEnabled(OcpsPolicy.UserFeedbackFormEnabled);
